import React, { useState, useEffect, Component } from 'react';
import { Link } from 'gatsby';
import { NoImage } from '../';
import LottieLoading from 'react-lottie';
import animationData from '../../LottieAnimations/bouncing_circles.json';
import moment from 'moment';
import style from './style.module.scss';

const EventCell = (props) => {

    const [imageHasLoaded, setImageHasLoaded] = useState(false);

    useEffect(() => {
        console.log("props.photos: ", props.photos);
        let { photo = [] } = props;
        let { location = '' } = photo[0] || {}
        if (location) {
            var eventImage = new Image;
            eventImage.onload = () => setImageHasLoaded(true);
            eventImage.src = location
        } else { setImageHasLoaded(true) }

    }, [props.photos])

    const toggleLoadingImage = () => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return <LottieLoading
            options={defaultOptions}
            height={275}
            width={275} />
    }

    const { photos = [], name = 'No Name', datetime = new Date(), id } = props;
    const formattedDate = moment(new Date(datetime).toLocaleString()).format('LLLL');
    return (
        <Link className={style.eventItem} to={`/single-event?id=${id}`}>
            {
                photos.length ? imageHasLoaded ? <span className={style.imageWrapper}> <img src={photos[0].location} alt="Event Photo" /></span>
                    : toggleLoadingImage() : <NoImage />
            }
            <span className={style.eventName}>{name}</span>
            <span className={style.date}>{formattedDate}</span>
        </Link>

    );
};

export default EventCell;